import React from 'react';
import '../../styles/common.css';
import styles from './PrivacyPolicy.module.css';
import Contacts from '../Contacts/Contacts';

const PrivacyPolicy = () => {
  const sections = [
    {
      id: 1,
      title: '1. Общие положения',
      items: [
        {
          number: '1.1',
          text: 'Настоящая Политика конфиденциальности (далее — «Политика») регулирует порядок обработки и защиты персональных данных пользователей сайта https://interworld.fun/ (далее — «Сайт») и игровых серверов проекта Interworld.'
        },
        {
          number: '1.2',
          text: 'Используя Сайт, Пользователь подтверждает своё согласие с условиями Политики в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных». Если Пользователь не согласен с условиями — он обязан прекратить использование Сайта.'
        },
        {
          number: '1.3',
          text: 'Оператором персональных данных является: Самозанятый Сопов Артем Игоревич (ИНН: 780737781518, плательщик налога на профессиональный доход).'
        }
      ]
    },
    {
      id: 2,
      title: '2. Сбор и состав информации',
      items: [
        {
          number: '2.1',
          text: 'Оператор придерживается принципа минимизации обрабатываемых данных. При использовании Сайта и оформлении цифровых услуг Оператор осуществляет сбор исключительно следующих данных: игровой никнейм (псевдоним) Пользователя на сервере Hytale; техническая информация (IP-адрес, файлы cookies, данные о браузере), собираемая автоматически в целях обеспечения безопасности Сайта.'
        },
        {
          number: '2.2',
          text: 'Оператор не собирает и не обрабатывает: адреса электронной почты, номера телефонов, паспортные данные, платёжные реквизиты (номера банковских карт и т.д.), логины и пароли от аккаунтов Hytale или иных платформ.'
        },
        {
          number: '2.3',
          text: 'Вся обработка платёжной информации, необходимой для совершения транзакций, осуществляется исключительно на стороне уполномоченного платёжного сервиса (Robokassa) в соответствии с его собственными политиками конфиденциальности.'
        },
        {
          number: '2.4',
          text: 'Правовым основанием обработки персональных данных является согласие субъекта персональных данных (п. 1 ч. 1 ст. 6 Федерального закона № 152-ФЗ), а также необходимость исполнения договора (Публичной оферты), стороной которого является Пользователь.'
        }
      ]
    },
    {
      id: 3,
      title: '3. Цели обработки информации',
      items: [
        {
          number: '3.1',
          text: 'Данные обрабатываются исключительно для следующих целей: исполнение обязательств по Публичной оферте на оказание цифровых услуг (автоматическое зачисление внутриигровой валюты на указанный никнейм); обеспечение работоспособности и безопасности функционала Сайта; ведение статистического учёта и защита от DDoS-атак или мошеннических действий.'
        }
      ]
    },
    {
      id: 4,
      title: '4. Передача информации третьим лицам',
      items: [
        {
          number: '4.1',
          text: 'Оператор не передаёт собранные данные третьим лицам, за исключением случаев: исполнения законных требований уполномоченных государственных органов РФ; обмена техническими идентификаторами с платёжной системой Robokassa исключительно в объёме, необходимом для идентификации успешного платежа и выдачи цифровой услуги.'
        }
      ]
    },
    {
      id: 5,
      title: '5. Хранение и защита данных',
      items: [
        {
          number: '5.1',
          text: 'Данные хранятся на серверах, находящихся на территории Российской Федерации, в течение срока, необходимого для достижения целей обработки.'
        },
        {
          number: '5.2',
          text: 'Оператор применяет организационные и технические меры защиты данных от неправомерного доступа, уничтожения, изменения или копирования, включая шифрование соединений (SSL).'
        }
      ]
    },
    {
      id: 6,
      title: '6. Права субъекта персональных данных',
      items: [
        {
          number: '6.1',
          text: 'Пользователь имеет право: получать информацию об обработке своих данных; требовать уточнения, блокирования или уничтожения данных; отозвать согласие на обработку.'
        },
        {
          number: '6.2',
          text: 'Для реализации своих прав Пользователь может обратиться в службу поддержки по электронной почте: support@interworld.fun.'
        }
      ]
    },
    {
      id: 7,
      title: '7. Изменения в Политике',
      items: [
        {
          number: '7.1',
          text: 'Оператор вправе вносить изменения в настоящую Политику без предварительного уведомления Пользователей.'
        },
        {
          number: '7.2',
          text: 'Новая редакция Политики вступает в силу с момента её публикации на Сайте.'
        }
      ]
    },
    {
      id: 8,
      title: '8. Реквизиты Оператора',
      items: [
        {
          number: '',
          text: 'Самозанятый: Сопов Артем Игоревич\nИНН: 780737781518\nЭлектронная почта: support@interworld.fun'
        }
      ]
    }
  ];

  return (
    <main className={`container ${styles.privacyPolicy}`}>
      <div className="container">
        <div style={{marginTop: '1rem'}}>
          <header className={styles.header}>
            <h1 className="title">Политика конфиденциальности</h1>
            <p className={styles.subtitle}>Порядок обработки и защиты персональных данных. Дата вступления в силу: 21 июля 2026 г.</p>
          </header>

          <div className={styles.sectionsContainer}>
            {sections.map((section) => (
              <div key={section.id} className={`glassCard ${styles.section}`}>
                <h2 className={styles.sectionTitle}>{section.title}</h2>
                <div className={styles.itemsList}>
                  {section.items.map((item, index) => (
                    <div key={index} className={styles.item}>
                      {item.number && (
                        <span className={styles.itemNumber}>{item.number}</span>
                      )}
                      <p className={styles.itemText}>{item.text}</p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className={styles.footer}>
            <p className={styles.updateDate}>Дата последнего обновления: 21 июля 2026 г.</p>
          </div>

          <div className={styles.contactsSection}>
            <Contacts />
          </div>

        </div>
      </div>
    </main>
  );
};

export default PrivacyPolicy;
